import { render, staticRenderFns } from "./ProposalSummary.vue?vue&type=template&id=475cba72"
import script from "./ProposalSummary.vue?vue&type=script&lang=js"
export * from "./ProposalSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports